import { memo } from 'react';
import { Handle, Position } from 'reactflow';

import { VisuallyHidden } from '@components/visually-hidden';

import { ACTION_TYPES } from 'ui/actions/action-config';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

const ACTION_TYPE = ACTION_TYPES.hidden;

export const Node = memo((node: JourneyNode<typeof ACTION_TYPE>) => {
  return (
    <NodeContainer node={node} hideSourceHandle hideTargetHandle>
      <VisuallyHidden>
        <Handle type="target" position={Position.Top} />
      </VisuallyHidden>
      <div style={{ width: 1, height: 1, backgroundColor: 'transparent' }} />
    </NodeContainer>
  );
});
